export default "__VITE_ASSET__DNiz4YYD__"